import { getAllIntegrations } from '@/lib/integrations-data';

// Every connection Open supports, icon + link, straight from the source of
// truth used by the /integrations pages. Shared by the EN and AR card sets.
export const CONNECTIONS = getAllIntegrations().map((i) => ({
  name: i.name,
  src: i.logoUrl,
  emoji: i.icon,
  href: `/integrations/${i.slug}`,
}));
